<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    centered
    :maskClosable="false"
    :destroyOnClose="true"
    :forceRender="true"
    @ok="handleSubmit"
    @cancel="handleCancel()"
    :confirmLoading="confirmLoading"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        @submit="handleSubmit"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item label="登录账号" prop="userCode">
          <a-input v-model="form.userCode" placeholder="请输入登录账号" />
        </a-form-model-item>
        <a-form-model-item label="密码" prop="password" v-if="type == 'add'">
          <a-input v-model="form.password" placeholder="请输入密码" />
        </a-form-model-item>
        <a-form-model-item
          label="确认密码"
          prop="secpassword"
          v-if="type == 'add'"
        >
          <a-input v-model="form.secpassword" placeholder="请输入确认密码" />
        </a-form-model-item>
        <a-form-model-item label="真实姓名" prop="userName">
          <a-input v-model="form.userName" placeholder="请输入真实姓名" />
        </a-form-model-item>
        <a-form-model-item label="电话号码" prop="telephone">
          <a-input v-model="form.telephone" placeholder="请输入电话号码" />
        </a-form-model-item>
        <a-form-model-item label="账号类型" prop="accountType">
          <a-select v-model="form.accountType" placeholder="请选择账号类型">
            <a-select-option
              :value="item.value"
              v-for="(item, index) in accountTypeList"
              :key="index"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="所属学校" prop="schoolId">
          <a-select v-model="form.schoolId" placeholder="请选择所属学校">
            <a-select-option
              :value="item.id"
              v-for="(item, index) in schoolList"
              :key="index"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="状态" prop="status">
          <a-radio-group v-model="form.status" button-style="solid">
            <a-radio-button
              :value="item.value"
              v-for="(item, index) in statusList"
              :key="index"
            >
              {{ item.label }}
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
import { Setting, SettingSchool } from "@/api";
export default {
  components: {},
  data() {
    let validatePass2 = (rule, value, callback) => {
      if (value !== this.form.password) {
        callback(new Error("两次输入的密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      title: "",
      type: "",
      confirmLoading: false,
      visible: false,
      formData: {
        userCode: "", //账号
        password: "", //密码
        secpassword: "",
        status: "1",
        telephone: "", //电话号码
        userName: "", //真实姓名
        accountType: undefined, //账号类型:SYS_USER_ACCOUNT_TYPE
        schoolId: undefined, //项目id,下拉框
      },
      form: {},
      accountTypeList: [],
      statusList: [],
      schoolList: [],
      rules: {
        userCode: [
          {
            required: true,
            message: "请输入登账号!",
            trigger: "change",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码!",
            trigger: "change",
          },
        ],
        secpassword: [
          { required: true, message: "请再次输入新密码!", trigger: "change" },
          { validator: validatePass2, trigger: "change" },
        ],
        userName: [
          {
            required: true,
            message: "请输入真实姓名!",
            trigger: "change",
          },
        ],
        // telephone: [
        //   {
        //     required: true,
        //     message: "请输入电话号码!",
        //     trigger: "change",
        //   },
        // ],
        accountType: [
          {
            required: true,
            message: "请选择账号类型!",
            trigger: "change",
          },
        ],
        schoolId: [
          {
            required: true,
            message: "请选择所属学校!",
            trigger: "change",
          },
        ],
        status: [
          {
            required: true,
            message: "请选择状态!",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {},
  created() {},
  methods: {
    async open(type, data) {
      this.type = type;
      this.title = type == "edit" ? "编辑账户" : "添加账户";
      this.visible = true;
      this.form = JSON.parse(JSON.stringify(this.formData));
      if (type == "edit" && data) {
        this.form = JSON.parse(JSON.stringify(data));
        this.form.status = data.status + "";
      }
      // 获取数据字典
      this.statusList = await this.common.getSysCodeType("SYS_STATUS");
      this.accountTypeList = await this.common.getSysCodeType(
        "USER_ACCOUNT_TYPE"
      );
      this.getSchool();
    },
    // 获取学校
    getSchool() {
      SettingSchool.schoolFindByPage({
        paging: {
          page: 1,
          limit: 999,
        },
      }).then(res => {
        if (res.code == this.config.pubCode) {
          this.schoolList = res.data;
        }
        this.confirmLoading = false;
      });
    },

    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let newForm = JSON.parse(JSON.stringify(this.form));
          // newForm.password = md5(newForm.password).toUpperCase();
          delete newForm.secpassword;
          if (this.type == "add") {
            delete newForm.id;
          } else if (this.type == "edit") {
            delete newForm.createTime;
            delete newForm.password;
          }
          this.addsave(newForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 添加提交
    addsave(data) {
      this.confirmLoading = true;
      Setting.sysUserSave(data).then(res => {
        if (res.code == this.config.pubCode) {
          this.pubMsg.tipMessage(
            this.type == "add" ? "添加成功！" : "修改成功！",
            "success"
          );
          this.handleCancel(1);
        }
        this.confirmLoading = false;
      });
    },
    handleCancel(data) {
      this.$emit("ok", data);
      this.visible = false;
      this.$refs.ruleForm.resetFields();
      this.form = JSON.parse(JSON.stringify(this.formData));
    },
  },
};
</script>
